"use client";

import Image from "next/image";
import { type CSSProperties, useEffect, useMemo, useState } from "react";

import { summitGalleryDays } from "@/components/home/summit-gallery-data";
import {
  getSummitHeroBucket,
  selectSummitHeroPhotoSets,
} from "@/lib/summitHeroPhotos";

const tileClasses = [
  "col-[1/3] row-[1/4] md:col-[1/5] md:row-[1/6]",
  "col-[3/5] row-[1/3] md:col-[5/9] md:row-[1/4]",
  "col-[3/5] row-[3/5] md:col-[9/13] md:row-[1/5]",
  "col-[1/3] row-[4/7] md:col-[5/8] md:row-[4/9]",
  "col-[3/5] row-[5/7] md:col-[8/11] md:row-[5/9]",
  "col-[1/2] row-[7/9] md:col-[1/5] md:row-[6/9]",
  "col-[2/5] row-[7/9] md:col-[11/13] md:row-[5/9]",
];

export const SummitHeroMosaic = () => {
  const [bucket, setBucket] = useState(0);
  const [activeSet, setActiveSet] = useState(0);
  const photoSets = useMemo(
    () => selectSummitHeroPhotoSets(summitGalleryDays, bucket),
    [bucket],
  );

  useEffect(() => {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const refresh = () => {
      setBucket(getSummitHeroBucket());
      if (!reduceMotion) setActiveSet(Math.floor(Date.now() / 5_000) % 3);
    };
    refresh();
    const timer = window.setInterval(refresh, 1_000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="absolute inset-0 bg-black">
      {photoSets.map((photos, setIndex) => (
        <div
          key={`${bucket}-${setIndex}`}
          data-active={setIndex === activeSet}
          aria-hidden={setIndex !== activeSet}
          className="summit-hero-scene absolute inset-0 grid grid-cols-4 grid-rows-8 gap-1.5 p-1.5 md:grid-cols-12 md:grid-rows-8 md:gap-2 md:p-2"
        >
          {photos.map((photo, index) => (
            <figure
              key={photo.src}
              className={`summit-hero-tile relative overflow-hidden ${tileClasses[index]}`}
              style={{ "--tile-delay": `${index * 65}ms` } as CSSProperties}
            >
              <Image
                src={photo.src}
                alt={photo.alt}
                fill
                priority={setIndex === 0 && index < 3}
                sizes={index < 3 ? "(min-width: 768px) 34vw, 50vw" : "(min-width: 768px) 25vw, 50vw"}
                className="object-cover"
              />
            </figure>
          ))}
        </div>
      ))}
    </div>
  );
};
